/*
Example use in sites:

import RedactorSending from 'sites/modules/redactor/RedactorSending.vue';
import components from '@/modules/form/config/site-components';

components.NxRedactorSending = RedactorSending;
*/

export default {
  // Used to import site components before bootstrap the app
};
